<template lang="pug">
  include ../mixins
  div
    +b.de-card.--space_sm.--border_secondary(v-if="isAuthenticated")
      +b.P.de-text.--size_sm.--weight_bold.--height_xs.ma.--bottom_sm {{ _("Залиште своє враження. Допоможіть іншим визначитися з вибором") }}
      review-form(:product-id="productId")
    +b.de-card.--space_sm.--border_secondary(v-else)
      slot(name="auth")
    +b.ma.--top_sm
      slot(name="content")
      +b.ma.--top_xs-custom(v-if="content")
        renderer(
          :result="content"
          class-render="g-row g-row--appearance_spaced"
        )
    +b.ma.--top_sm(v-if="hasMoreLocal")
      row(justify="center")
        cell(cols="12 6-sm 4-md 3-xl")
          bem-button.de-text--size_2xs(
            appearance="fill-accent-1"
            space="sm"
            width="full"
            rounded="sm"
            @event="loadMore()"
          ) {{ _('Показати ще') }}
</template>

<script>
import { djangoToJsBoolean } from '@helpers/utils'
import { reviewListResource } from '@services/review.service.js'

export default {
  props: {
    hasMore: {},
    productId: {},
    productSlug: {},
  },

  data() {
    return {
      isAuthenticated: djangoToJsBoolean(window.is_auth),
      hasMoreLocal: this.hasMore,
      nextPage: 2,
      content: '',
    }
  },

  methods: {
    loadMore() {
      const params = {
        page: this.nextPage,
        product: this.productSlug,
      }
      reviewListResource.execute(params).then(res => {
        const { data, meta } = res
        this.content += data
        this.hasMoreLocal = meta.hasNextReviews
        if (this.hasMoreLocal) {
          this.nextPage++
        }
      })
    },
  },
}
</script>
